import { render, staticRenderFns } from "./RaceParticipantsSetup.vue?vue&type=template&id=189d2eb6&"
import script from "./RaceParticipantsSetup.vue?vue&type=script&lang=js&"
export * from "./RaceParticipantsSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports